import closeImmersiveReadingPane from 'owa-mail-actions/lib/closeImmersiveReadingPane';
import { lazyResetFocus } from 'owa-mail-focus-manager';
import { SxSEventNames, sxsStore, PreviewPaneSelectionSource } from 'owa-sxs-store';
import { isReadingPanePositionOff } from 'owa-mail-layout/lib/selectors/readingPanePosition';

/**
 * Called when SxS (side-by-side) preview pane is closed
 */
export default function onSxSPreviewPaneClose(previewSelectionSource: PreviewPaneSelectionSource) {
    if (isReadingPanePositionOff()) {
        /* If reading pane position is off and user is navigating back from a preview pane which was opened
        by selecting an inline preview from list view then we navigate the user back to list view.
        If preview pane was opened by clicking an attachment from reading pane then we navigate the user
        back to reading pane */
        switch (previewSelectionSource) {
            case PreviewPaneSelectionSource.MailList:
                /* We need to call close reading pane so that the
                 conversation correctly gets marked as read */
                closeImmersiveReadingPane();
                break;

            case PreviewPaneSelectionSource.ReadingPane:
            case PreviewPaneSelectionSource.ConversationAttachmentWell:
            default:
                break;
        }
    }

    // Reset focus based on priority list when we close the preview pane
    lazyResetFocus.importAndExecute();
}

sxsStore.eventManager.on(SxSEventNames.CloseEvent, onSxSPreviewPaneClose);
